import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import LogoutIcon from '@mui/icons-material/Logout'
import ContactSupportIcon from '@mui/icons-material/ContactSupport'
import { useMediaQuery, useTheme } from '@mui/material'

export type EndLocalConsultationDialogProps = {
  isEnding?: boolean
  onClose?: () => void
  onEndConsultation?: () => void
  onGenerateExpertise?: () => void
  open?: boolean
  onQuit?: () => void
}

const buttonStyle = {
  height: '60px',
}

export function EndLocalConsultationDialog(props: EndLocalConsultationDialogProps) {
  const { onClose, onGenerateExpertise, onEndConsultation, onQuit, open = false } = props
  const { t } = useTranslation()
  const theme = useTheme()
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true })

  return (
    <Dialog
      PaperProps={{
        sx: {
          minWidth: isMobileScreen ? '300px': '500px',
          minHeight:isMobileScreen ? '200px': '400px',
        },
      }}
      onClose={onClose}
      open={open}
    >
      <DialogContent>
        <Stack spacing={5}>
          <Stack direction="row" alignItems="center" justifyContent="center" spacing={3}>
            <Typography fontWeight={'bold'}>{t('component.ui.endLocalConsultationDialog.title')}</Typography>
            <Button onClick={onClose} color="error" variant="contained">
              {t('common:button.cancel.label')}
            </Button>
          </Stack>
          <Stack direction="column" alignItems="start" justifyContent="space-around" spacing={3}>

            <Button onClick={onGenerateExpertise} sx={buttonStyle} fullWidth variant="outlined">
              <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ width: '100%' }}>
                <span></span>
                <p>{t('component.ui.endLocalConsultationDialog.requestExpertiseButton.label')}</p>
                <ContactSupportIcon />
              </Stack>
            </Button>

            <Button sx={buttonStyle} fullWidth onClick={onEndConsultation} color="error" variant="outlined">
              <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ width: '100%' }}>
                <span></span>
                <p>{t('component.ui.endLocalConsultationDialog.endConsultationButton.label')}</p>
                <LogoutIcon />
              </Stack>
            </Button>

            {onQuit && (
              <Button sx={buttonStyle} fullWidth onClick={onQuit} color="error" variant="outlined">
                <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ width: '100%' }}>
                  <span></span>
                  <p>{t('component.ui.endLocalConsultationDialog.quitConsultationButton.label')}</p>
                  <LogoutIcon />
                </Stack>
              </Button>
            )}
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  )
}

export default EndLocalConsultationDialog
